import { apiCallStatus } from 'helpers/constants';
import { actionTypes } from '../DetailedInformation/SensorProperties/constants';
import { getApiActionCreator } from 'helpers/actionHelper';
import { AssetDetailsApi } from 'api';

export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};

const getSensorFeaturesAction = getApiActionCreator(actionTypes.GET_SENSOR_FEATURES);
const getSensorPropertiesAction = getApiActionCreator(actionTypes.GET_SENSOR_PROPERTIES);
const getSensorGatewayInfoAction = getApiActionCreator(actionTypes.GET_SENSOR_GATEWAYINFO);
// const getSensorTimeseriesConfigAction = getApiActionCreator(actionTypes.GET_SENSOR_TIMESERIES_CONFIG);
const getSensorTimeSeriesAction = getApiActionCreator(actionTypes.GET_SENSOR_TIMESERIES);
const getSensorRssiValueAction = getApiActionCreator(actionTypes.GET_SENSOR_RSSI_VALUE);
const getSensorBatteryLevelAction = getApiActionCreator(actionTypes.GET_SENSOR_BATTERY_LEVEL);

export const getSensorProperties = (sensorId) => {
    if (sensorId) {
        return (dispatch) => {
            dispatch(getSensorPropertiesAction(apiCallStatus.LOADING));
            AssetDetailsApi.getSensorProperties(sensorId)
                .then((data) => {
                    dispatch(getSensorPropertiesAction(apiCallStatus.SUCCESS, data));
                    dispatch(getSensorFeaturesAction(apiCallStatus.SUCCESS, data.sensorFeatures));
                },
                    (err) => {
                        dispatch(getSensorPropertiesAction(apiCallStatus.ERROR, null, err));
                    });
        };
    }
};

export const getSensorRssiValue = (sensorId) => {
    if (sensorId) {
        return (dispatch) => {
            dispatch(getSensorRssiValueAction(apiCallStatus.LOADING));
            AssetDetailsApi.getRssiValue(sensorId)
                .then((data) => {
                    dispatch(getSensorRssiValueAction(apiCallStatus.SUCCESS, data));
                },
                    (err) => {
                        dispatch(getSensorRssiValueAction(apiCallStatus.ERROR, null, err));
                    });
        };
    }
};

export const getSensorGatewayInfo = (sensorId, hasTrendCapability) => {
    const DCUGENERATION_PROPERTY = 'legacy';
    if (sensorId) {
        return (dispatch) => {
            dispatch(getSensorGatewayInfoAction(apiCallStatus.LOADING));
            AssetDetailsApi.getSensorGatewayInfo(sensorId)
                .then((data) => {
                    dispatch(getSensorGatewayInfoAction(apiCallStatus.SUCCESS, data));
                    if (data?.dcuGeneration !== null && data?.dcuGeneration !== DCUGENERATION_PROPERTY) {
                        // hasTrendCapability && actions.getSensorTimeSeriesConfig(details.sensorId);
                        hasTrendCapability && dispatch(getSensorRssiValue(sensorId));
                    }
                    else {
                        dispatch({ type: actionTypes.CLEAR_TIMESERIES_STORE });
                    }
                },
                    (err) => {
                        dispatch(getSensorGatewayInfoAction(apiCallStatus.ERROR, null, err));
                    });
        };
    }
};

export const getSensorBatteryLevel = (sensorId) => {
    if (sensorId) {
        return (dispatch) => {
            dispatch(getSensorBatteryLevelAction(apiCallStatus.LOADING));
            AssetDetailsApi.getSensorBatteryLevel(sensorId)
                .then((data) => {
                    dispatch(getSensorBatteryLevelAction(apiCallStatus.SUCCESS, data));
                },
                    (err) => {
                        dispatch(getSensorBatteryLevelAction(apiCallStatus.ERROR, null, err));
                    });
        };
    }
};

export const getSensorTimeSeries = (sensorId, sensorTimeseriesKey) => {
    const sensors =
        [
            {
                sensorId: sensorId,
                timeseriesKeys: sensorTimeseriesKey
            }
        ];
    if (sensorId) {
        return (dispatch) => {
            dispatch(getSensorTimeSeriesAction(apiCallStatus.LOADING));
            AssetDetailsApi.getSensorTimeSeries(sensors)
                .then((data) => {
                    dispatch(getSensorTimeSeriesAction(apiCallStatus.SUCCESS, data));
                },
                    (err) => {
                        dispatch(getSensorTimeSeriesAction(apiCallStatus.ERROR, null, err));
                    });
        };
    }

};

// export const getSensorTimeSeriesConfig = (sensorId) => {
//     if (sensorId) {
//         // This action is used to fetch the sensor timeseries configuration
//         return (dispatch) => {
//             dispatch(getSensorTimeseriesConfigAction(apiCallStatus.LOADING));
//             AssetDetailsApi.getSensorTimeseriesConfig(sensorId)
//                 .then((data) => {
//                     dispatch(getSensorTimeseriesConfigAction(apiCallStatus.SUCCESS, data));
//                     if (data && data?.timeseries?.length > 0) {
//                         const sensorTimeseriesKey = data.timeseries?.map((item) => item.timeseriesKey);
//                         // If timeseries config is available, fetch the sensor timeseries info
//                         dispatch(getSensorTimeSeries(sensorId, sensorTimeseriesKey));
//                     }
//                     else {
//                         dispatch({ type: actionTypes.CLEAR_TIMESERIES_STORE });
//                     }
//                 },
//                     (err) => {
//                         dispatch(getSensorTimeseriesConfigAction(apiCallStatus.ERROR, null, err));
//                     });
//         };
//     }
// };

